@use "sass:color";

.mvWrapper {
    display: flex;
    flex-direction: column;
    background-color: white;
    border: 1px solid #dfdfdf;
    border-radius: 5px;
    margin-bottom: 1rem;
    position: relative;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
    padding: 0;

    &.open {
        .mvAreaFormWrapper {
            display: flex;
        }

        .mvTypeFiltersContainer {
            display: block;
        }

        .mvTopBar {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

        .mvAreaAddresses {
            border-color: #dfdfdf;
        }

        &.selected {
            .mvAreaAddresses {
                border-color: #f28e3d;
            }
        }
    }

    &.selected {
        border-color: #f28e3d;
    }

    .disabled {
        opacity: 0.75;
    }
}

.mvTopBar {
    display: flex;
    align-items: center;
    border-bottom: 1px solid lightgray;
    flex-shrink: 0;
    background-color: #ffffff;
    border-bottom: 1px solid #dfdfdf;
    border-radius: 5px;

    .selected & {
        border-color: #f28e3d80;
    }

    > button {
        padding: 1rem;
        cursor: pointer;
        appearance: none;
        border: 0;
        font-size: 16px;
        background-color: transparent;

        &:first-of-type {
            font-weight: 700;
            color: #14456b;
        }
    }
}

.mvAreaRemoveButton {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    appearance: none;
    cursor: pointer;
    background-color: white;
    border: 1px solid #cb000080;
    transition: background-color 0.2s ease-in-out;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
    position: absolute;
    right: -10px;
    top: -10px;

    &:hover {
        background-color: #fff2f2;
    }

    svg {
        width: 8px;
    }
}

.mvAreaFormWrapper {
    display: none;
    width: 100%;
    flex-wrap: wrap;
    padding: 1rem 0.75rem;
    align-items: flex-start;
    border-bottom: 1px solid #dfdfdf;
}

.mvArrowIcon {
    width: 13px;
    margin-right: 1rem;
    transform: rotate(180deg);

    &.open {
        transform: rotate(0);
    }
}

.mvAreaFormItem {
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: stretch;
    width: 50%;
    padding: 0 0.5rem;
}

.mvTypeFiltersContainer {
    padding: 1rem;
    display: none;
}

.mvTypeFilters {
    display: flex;
    padding: 0.5rem 0;
    margin-top: 0.5rem;

    > label {
        display: flex;
        align-items: center;
        margin-right: 1.5rem;
        cursor: pointer;
        span {
            font-weight: 400;
            padding-left: 0.3rem;
            padding-bottom: 0.1rem;
        }
    }
}

.mvLoadingIcon {
    margin-right: 0.5rem;
    width: 3rem;
    position: absolute;
    left: 50%;
    bottom: 50%;
    transform: translate(-50%, 50%);
}

.mvEditButton {
    color: #00000080;
    border: 0;
    background: transparent;
    appearance: none;
    width: auto;
    cursor: pointer;
    padding-left: 0 !important;
    &:hover {
        color: #000000bf;
    }
}

.mvAreaError {
    color: rgb(199, 49, 49);
    padding: 0.5rem 1rem 0 1rem;
    display: block;
    width: 100%;
    text-align: left;
    font-size: 0.85rem;
}

.mvFetchResults {
    list-style-type: none;
    padding: 0;
    border: 1px solid #14456b33;
    font-size: 0.9rem;
    border-radius: 5px;
    overflow: hidden;
    width: 100%;
    display: flex;
    margin-top: 0;
    margin-bottom: 0;
    flex-direction: column;
}

.mvFetchResultsContainer {
    padding: 0.25rem 0.5rem;
    border-radius: 5px;
    width: 100%;
    h3 {
        margin-bottom: 0.4rem;
        font-size: 0.9rem;
        font-weight: 600;
        margin-top: 0.5rem;
    }
}

.mvFetchResult {
    padding: 0.25rem 0.5rem;
    display: flex;
    align-items: center;
    width: 100%;
    border: 0;
    appearance: none;
    background-color: rgba(0, 0, 0, 0.025);
    font-weight: 600;
    color: #14456b;
    cursor: pointer;
    border-bottom: 1px solid #14456b33;

    &:last-child {
        border-bottom: 0;
    }
}

.mvAreaUseFetchResultButton {
    margin-left: auto;
    border-radius: 5px;
    background-color: #f28e3d;
    text-transform: uppercase;
    padding: 0.5rem 1rem;
    cursor: pointer;
    color: #ffffff;
    transition: background-color 0.2s ease-in-out;
    &:hover {
        background-color: color.adjust(#f28e3d, $lightness: -5%);
    }
}

.mvFetchMarker {
    width: 11px;
    margin-right: 0.25rem;
}

.mvAreaAddresses {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.875rem;
    font-weight: 600;
    color: #14456b;
    border-top: 1px solid transparent;
    > span {
        padding: 1rem;
    }
}

.mvAreaFilters {
    flex-grow: 1;
    position: relative;
}

.mvLoadingOverlay {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 20;
    background-color: rgba(255, 255, 255, 0.75);
}
